import * as angular from 'angular';
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {AgentDialogService} from "../../services/agent-dialogs-service.service";
import {AgentsAlerts} from "../../services/agents-alerts.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {BatchDialogService} from "../../../batch/services/batch-dialogs-service.service";
import {BatchRequestsService} from "../../../batch/services/batch-requests.service";
import {ConfirmChangeStateService} from "../../../commons/services/confirm-change-state.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {AgentModel} from "../../angular/models/agent.model";

export class uploadAgentsViewCtrl implements IController {

  private readonly siteId: any;
  private agents: any;
  private errorAgents: any;
  private warningAgents: any;
  private currentNavItem: any;
  private totals: any;
  private selectedIds: any;
  private queryString: any;
  private doUpdate: any;
  private uploadComplete: any;

  /* @ngInject */
  constructor(private agentDialogService: AgentDialogService, private batchDialogService: BatchDialogService, private agentsAlerts: AgentsAlerts,
              private confirmDialogService: ConfirmDialogService, private confirmChangeStateService: ConfirmChangeStateService, private agentConstants,
              private splitService: SplitService, private $log, private UUIDService,
              private batchRequestsService: BatchRequestsService, private bringozLoaderService: BringozLoaderService, private $q: IQService) {
    this.siteId = this.splitService.getSiteId();
  }

  $onInit() {
    this.doUpdate = false;
    this.uploadComplete = false;
    this.currentNavItem = 'total';
    this.selectedIds = [];
    this.agents = [];
    this.errorAgents = [];
    this.warningAgents = [];
    this.totals = {};
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  changeNavItem(item) {
    this.currentNavItem = item;

    this.errorAgents = [];
    this.warningAgents = [];
    this.selectedIds = [];

    if (item === 'total') {
      this.agents = this._resetAgents(this.agents, this._getErrorAgents(this.agents), this._getWarningAgents(this.agents));
    }
    if (item === 'errors') {
      this.errorAgents = this._getErrorAgents(this.agents);
    }
    if (item === 'warnings') {
      this.warningAgents = this._getWarningAgents(this.agents);
    }
  }

  onUpload(event) {
    this.agentDialogService.importAgents(event)
      .then((agents) => {
        agents = this._setAllAgentsIds(agents);
        this.agents = this.agents.concat(agents);
        if (this.currentNavItem === 'errors') {
          this.errorAgents = this._getErrorAgents(this.agents);
        }
        if (this.currentNavItem === 'warnings') {
          this.warningAgents = this._getWarningAgents(this.agents);
        }
        this.totals = this._getTotals(this.agents);
        this.uploadComplete = true;
        this.confirmChangeStateService.setIsEnabled(true);
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to upload file', error);
        } else {
          this.$log.info('Dialog Closed')
        }
      })
  }

  onQueryChange(query) {
    this.queryString = query;
  }

  onSelectedIdsChanged(selectedIds) {
    this.selectedIds = selectedIds;
  }

  onRemoveAgents(ids) {
    this.agents = _.filter(this.agents, (agent) => {
      return _.indexOf(ids, agent.agentId) === -1;
    });
    this.totals = this._getTotals(this.agents);
    if (!this.agents.length) {
      this.uploadComplete = false;
    }
  }

  onRemoveErrorAgents(ids) {
    this.errorAgents = _.filter(this.errorAgents, (agent) => {
      return _.indexOf(ids, agent.agentId) === -1
    });
    this.agents = this._resetAgents(this.agents, this.errorAgents, this._getWarningAgents(this.agents));
    this.totals = this._getTotals(this.agents);
    if (!this.agents.length) {
      this.uploadComplete = false;
    }
  }

  onRemoveWarningAgents(ids) {
    this.warningAgents = _.filter(this.warningAgents, (agent) => {
      return _.indexOf(ids, agent.agentId) === -1
    });
    this.agents = this._resetAgents(this.agents, this._getErrorAgents(this.agents), this.warningAgents);
    this.totals = this._getTotals(this.agents);
    if (!this.agents.length) {
      this.uploadComplete = false;
    }
  }

  onEditAgent(agent, event) {
    this.agentDialogService.editAgent(event, agent.entity, true)
      .then((payload: {agent: AgentModel, autoStopRecordingIntervalMinutes?: boolean}) => {
        const agentCopy = angular.copy(agent);
        agentCopy.entity = payload.agent;
        this.onSaveEditing(agentCopy);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      });
  }

  onSaveEditing(editingAgent) {
    _.unset(editingAgent, 'mappingErrors');
    if (this.currentNavItem === 'errors') {
      const updatedErrorAgents = this._updateAgent(this.errorAgents, editingAgent);
      this.agents = this._resetAgents(this.agents, updatedErrorAgents, this._getWarningAgents(this.agents));

      this.errorAgents = _.filter(updatedErrorAgents, (agent) => {
        return agent.agentId !== editingAgent.agentId;
      });
    }
    if (this.currentNavItem === 'warnings') {
      this.warningAgents = this._updateAgent(this.warningAgents, editingAgent);
      this.agents = this._resetAgents(this.agents, this._getErrorAgents(this.agents), this.warningAgents);
    }
    else {
      this.agents = this._updateAgent(this.agents, editingAgent);
    }
    this.totals = this._getTotals(this.agents);
  }

  onMultipleDelete(ids) {
    if (this.currentNavItem === 'errors') {
      this.onRemoveErrorAgents(ids);
    }
    if (this.currentNavItem === 'warnings') {
      this.onRemoveWarningAgents(ids);
    }
    else {
      this.onRemoveAgents(ids);
    }
    this.selectedIds = [];
  }

  onCancel(event) {
    return this.confirmDialogService.confirm('Cancel Upload','Are you sure you want to cancel the upload?',event)
      .then(() => {
        this.agents = [];
        this.errorAgents = [];
        this.currentNavItem = 'total';

        this.totals = {};
        this.selectedIds = [];
        this.uploadComplete = false;
        this.confirmChangeStateService.reset();
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onCreate(event) {
    const agents = _.map(angular.copy(this.agents), (agent) => {
      agent.confirm = true;
      return agent;
    });

    const serverErrorsCount = this._getWarningAgents(agents).length;
    this._confirmCreate(serverErrorsCount, event)
      .then(() => {
        this.bringozLoaderService.on();
        return this.batchRequestsService.createAgentsBatch(agents, this.doUpdate);
      })
      .then((batch) => {
        this.bringozLoaderService.off();
        return this.batchDialogService.batchAgentsProgress(event, batch);
      })
      .then((errorItems) => {
        const errorRowNumbers = _.map(errorItems, 'rowNumber');
        let errorAgents = _.chain(this.agents)
          .filter((o) => {
            return _.includes(errorRowNumbers, o.rowNumber)
          })
          .map((filteredAgent) => {
            const errorItem = _.find(errorItems, (errorItem) => {
              return filteredAgent.rowNumber === errorItem.rowNumber;
            })
            filteredAgent.mappingErrors = _.get(errorItem, 'mappingErrors', []);
            return filteredAgent;
          })
          .value();

        errorAgents = this._setAllAgentsIds(errorAgents);
        this.agents = errorAgents;
        this.totals = this._getTotals(errorAgents);

        if (this.currentNavItem === 'errors') {
          this.errorAgents = this._getErrorAgents(errorAgents);
        }
        if (this.currentNavItem === 'warnings') {
          this.warningAgents = this._getWarningAgents(errorAgents);
        }
        if (!this.agents.length) {
          this.uploadComplete = false;
        }
      })
      .catch((error) => {
        if (error) {
          this.agentsAlerts.createManyError(error);
          this.$log.error('Failed to create batch', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  onDownloadExample() {
    const downloadUrl = this.agentConstants.importSampleFileLink;
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = "import-agents-example.xls";
    document.body.appendChild(a);
    a.click();
  }

  // ******************************
  //        Private methods
  // ******************************

  private _setAllAgentsIds(agents) {
    return _.map(agents, (agent) => {
      agent.agentId = this.UUIDService.generate();
      return agent;
    })
  }

  private _getTotals(agents) {
    const errors = _.reduce(agents, (sum: any, agent) => {
      return sum + !_.isEmpty(agent.mappingErrors);
    }, 0);

    const warnings = _.reduce(agents, (sum: any, agent) => {
      const warningList = _.filter(_.get(agent, 'errors', []), (error) => {
        return error.fieldName === 'server';
      });
      return sum + warningList.length;
    }, 0);
    return {
      total: agents.length,
      errors: errors,
      warnings: warnings
    }
  }

  private _getErrorAgents(agents) {
    return _.filter(agents, (agent) => {
      const errorList = _.filter(_.get(agent, 'mappingErrors', []), (error) => {
        return error.fieldName !== 'server';
      });
      return errorList.length > 0;
    });
  }

  private _getWarningAgents(agents) {
    return _.filter(agents, (agent) => {
      return _.filter(_.get(agent, 'mappingErrors', []), (error) => {return error.fieldName === 'server';}).length > 0;
    })
  }

  private _updateAgent(agents, editingAgent) {
    return _.map(agents, (agent) => {
      if (agent.agentId === editingAgent.agentId) {
        return editingAgent;
      }
      return agent;
    });
  }

  private _resetAgents(agents, errorAgents, warningAgents) {
    const filteredAgents = _.filter(agents, (agent) => {
      return !agent.mappingErrors || !agent.errors.mappingErrors;
    });
    return _.chain(filteredAgents)
      .concat(errorAgents, warningAgents)
      .uniqWith(_.isEqual)
      .value();
  }

  private _confirmCreate(serverErrorsCount, event) {
    return serverErrorsCount > 0 ?
      this.confirmDialogService.confirm('Unhandled Warning',
        'There are some unhandled warnings, are you sure you want to continue?', event) :
      this.$q.all(undefined);
  }

}

angular
  .module('bringoz.admin.agents')
  .component('uploadAgentsView', {
    bindings: {},
    template: require('./upload-agents-view.html').default,
    controller: uploadAgentsViewCtrl
  });
